import { HorseSex, PostDisplay } from '$types'
import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'app-main-info',
  templateUrl: './main-info.component.html',
  styleUrls: ['./main-info.component.css']
})
export class MainInfoComponent {

  @Input() post!: PostDisplay;
  @Input() editable: boolean = false;
  @Output() renewPost = new EventEmitter<PostDisplay>();
  @Output() updatePost = new EventEmitter<PostDisplay>();
  @Output() deletePost = new EventEmitter<PostDisplay>();
  isMale(): boolean {
    if(this.post.horse.sex){
      return this.post.horse.sex.toUpperCase() == HorseSex.MALE.toUpperCase()
    }
    return false;
  }
  isFemale(): boolean {
    if(this.post.horse.sex){
      return this.post.horse.sex.toUpperCase() == HorseSex.FEMALE.toUpperCase()
    }
    return false;
  }
  isHongre(): boolean {
    if(this.post.horse.sex){
      return this.post.horse.sex.toUpperCase() == HorseSex.HONGRE.toUpperCase()
    }
    return false;
  }
  getAge() {
    let age = new Date().getFullYear() - this.post.horse.birthYear;
    return age <= 1 ? age.toString().concat(" AN") : age.toString().concat(" ANS");
  }
}
